import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./licence.css";

export default function Licence() {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = "Licences | DEV4";
        return () => {
            document.title = previousTitle;
        };
    }, []);

    return (
        <main className="below-navbar d4-container licence-page">
            <article aria-labelledby="licence-title">
                <h1 id="licence-title">Licences</h1>
                <p>Select a licence to view its available versions.</p>
                <ul>
                    <li><Link to="/licence/infrastructure">Infrastructure licence</Link></li>
                </ul>
            </article>
        </main>
    );
}
